/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import { orderBy, get, clone } from '../utils/lodash-utils';
export const sortColumns = (sortColumn, sortOrder, originalData) => {
  let newSortedData = null
  if (sortColumn === 'name') {
    let lowerCaseData = clone(originalData);
    lowerCaseData = lowerCaseData.map((sysName) => {
      sysName.name = sysName.name.toLowerCase();
      return sysName;
    });
    newSortedData = orderBy(
      lowerCaseData,
      [
        function(o) {
          return get(o, 'name', '').toLowerCase()
        },
      ],
      sortOrder
    )
  }else if (sortColumn === 'attributes.DisplayName') {
    newSortedData = orderBy(
      originalData,
      [
        function(o) {
          return get(o, 'attributes.DisplayName[0]', '').toLowerCase()
        },
      ],
      sortOrder
    )
  } else if (sortColumn === 'maxAlarmSeverity.value') {
    newSortedData = orderBy(originalData, ['maxAlarmSeverity.value', 'maxAlarmSeverity.cnt',function(o) { return get(o, 'name', '').toLowerCase() }], [sortOrder, sortOrder, 'asc'])
  } else if (sortColumn === 'busType') {
    newSortedData = orderBy(
      originalData,
      [
        function(o) {
          let busType = get(o, 'busType', '')
          return busType === 'hub' || busType === 'robot'
        },
      ],
      sortOrder
    )
  } else if (sortColumn === 'ipAddresses') {
    newSortedData = orderBy(
      originalData,
      [
        function(o) {
          return get(o, 'ipAddresses', []).join(', ')
        },
      ],
      sortOrder
    )
  } else if (sortColumn === 'attributes.create_time') {
	  let sortOrderUpdated = ''
	  if(sortOrder != ''){
		 sortOrderUpdated = sortOrder === "asc" ? "desc" : "asc";
	  }
	    newSortedData = orderBy(
	      originalData,
	      [
	        function(o) {
	          return get(o, 'attributes.create_time', '')
	        },
	      ],
	      sortOrderUpdated
	    )
  } else if (sortColumn === 'attributes.monitoredBy') {
    newSortedData = orderBy(
      originalData,
      [
        function(o) {
          return get(o, 'attributes.monitoredBy', [])
            .sort()
            .join(', ')
        },
      ],
      sortOrder
    )
  } else {
    newSortedData = orderBy(originalData, sortColumn, sortOrder)
  }
  return newSortedData
}
